import React from 'react';
import { useTranslation } from 'react-i18next';

const Discuss = () => {
  const { t } = useTranslation();

  return (
    <div className="text-white">
      <p dangerouslySetInnerHTML={{ __html: t('discussContent') }}></p>
    </div>
  );
};

export default Discuss;